<template>
  <div class="container px-3 pt-0">
    <div class="mb-3 fs-6">
      {{ t("CREDIT_LINE_FEEDBACK.WHY_UNLINK_BANK_ACCOUNT") }}
    </div>

    <OptionsSelector :options="options" @onChange="handleOptionSelected" />

    <div class="floating-btn-placeholder" />

    <div class="floating-btn">
      <Button
        id="btn-continue"
        class="text-center w-100 p-3"
        @click="handleExitClick"
        :secondary="true"
      >
        <span class="my-auto fw-bold">
          {{ t("CREDIT_LINE_FEEDBACK.GO_TO_HOME") }}
        </span>
      </Button>
      <Button
        id="btn-continue"
        class="text-center w-100 p-3"
        :disabled="!selectedAnswer"
        @click="handleSubmitClick"
      >
        <span class="text-white my-auto fw-bold">
          {{ t("CREDIT_LINE_FEEDBACK.SUBMIT_FEEDBACK") }}
        </span>
      </Button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import Button from "@/apps/credit-line/components/Button.vue";
import OptionsSelector from "@/apps/credit-line/components/OptionsSelector.vue";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";

declare const Android: AndroidInterface;

export default defineComponent({
  name: "PostUnlinkSurvey",
  components: { Button, OptionsSelector },
  emits: ["next", "setScreenTitle"],
  setup() {
    const { t } = useI18n();
    const loading = ref<boolean>(false);
    const selectedAnswer = ref<string>("");
    const options = [
      t("CREDIT_LINE_FEEDBACK.UNLINK_BANK_ACCOUNT_OPTION_1"),
      t("CREDIT_LINE_FEEDBACK.UNLINK_BANK_ACCOUNT_OPTION_2"),
      t("CREDIT_LINE_FEEDBACK.UNLINK_BANK_ACCOUNT_OPTION_3"),
    ];

    onMounted(() => {
      logAnalyticsEvent(
        AnalyticEvents.CreditLine.UnlinkBankAccountSurveyScreenView,
        "CLSurveys"
      );
    });

    return {
      t,
      selectedAnswer,
      loading,
      options,
    };
  },
  methods: {
    handleOptionSelected(option: { index: number; value: string }) {
      this.selectedAnswer = option.value;
    },
    handleSubmitClick() {
      logAnalyticsEvent(
        AnalyticEvents.CreditLine.UnlinkBankAccountSurveySubmit,
        "CLSurveys",
        this.selectedAnswer
      );
      this.$emit("next", {});
    },
    handleExitClick() {
      Android.dismissWebView();
    },
  },
  mounted() {
    this.$emit("setScreenTitle", this.t("CL_WITHDRAWAL.UNLINK_ACCOUNT_TITLE"));
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.floating-btn-placeholder,
.floating-btn {
  height: 140px;
  width: 100%;
}
.floating-btn {
  background-color: white;
  position: fixed;
  padding: 10px 20px;
  left: 0;
  bottom: 0;
  z-index: 200;
}
</style>
